import '../styles/ProductsWithList.scss';

const SashWeights = () => {
    return (
        <div className='main'>
            <h1>Sash Weights</h1>
            <h3>USED TO COUNTERBALANCE THE WEIGHT OF A SLIDING SASH IN A SASH WINDOW SO THE WINDOW POSITION CAN BE HELD AT ANY HEIGHT</h3>
            <p>Available in 1.5" x 1.5" square shape. We can cut the sash weights to your desired lengths, up to 6 feet long.</p>
            <img className='img-sash-weight' src='https://user-images.githubusercontent.com/77664153/180884978-06bc0550-e93c-4eb7-9a0f-c3dd8bcdc4de.png' alt='example of a sashweight'></img>
        </div>
    );
    
};

export default SashWeights;